export function setupSearch() {
    const search = document.querySelector('.navigation__search');
    const searchToggleBtn = document.getElementById('search-toggle-btn');
    const searchBarLI = document.getElementById('navigation-searchbar');
    const searchBarInput = document.getElementById('q');
    const searchBarIcon = document.getElementById('searchbar-icon');
    const searchClose = document.getElementById('search-close');

    document.body.addEventListener('keyup', event => {
        if (event.code && event.code.toLowerCase() == 'escape') {
            closeSearchBar();
        }
    });

    document.body.addEventListener('click', event => {
        if (document.body.classList.contains('active-searchbar') && (!event.path.includes(search) && !event.path.includes(searchToggleBtn))) {
            toggleSearchBar();
        }
    });

    if (searchToggleBtn) {
        searchToggleBtn.addEventListener('click', toggleSearchBar);
    }

    if (searchBarIcon) {
        searchBarIcon.addEventListener('click', toggleSearchBar);
    }

    if (searchClose) {
        searchClose.addEventListener('click', toggleSearchBar);
    }

    function toggleSearchBar() {
        document.body.classList.toggle('active-searchbar');

        if (document.body.classList.contains('active-searchbar')) {
            searchBarInput.focus();
        }
    }
};

export function closeSearchBar() {
    document.body.classList.remove('active-searchbar');
}
